// Review slider
document.addEventListener('DOMContentLoaded', function(){
  var track = document.getElementById('revTrack');
  if(!track) return;
  var index = 0;
  var total = track.children.length;
  var startX = 0;
  var isDragging = false;

  function goTo(i){
    index = (i + total) % total;
    track.style.transform = 'translateX(-' + (index * 100) + '%)';
  }

  track.addEventListener('touchstart', function(e){ startX = e.touches[0].clientX; },{passive:true});
  track.addEventListener('touchend', function(e){
    var diff = startX - e.changedTouches[0].clientX;
    if(Math.abs(diff) > 40) goTo(diff > 0 ? index+1 : index-1);
  });
  track.addEventListener('mousedown', function(e){ isDragging=true; startX=e.clientX; track.style.cursor='grabbing'; });
  track.addEventListener('mouseup', function(e){
    if(!isDragging) return;
    isDragging=false;
    track.style.cursor='grab';
    var diff = startX - e.clientX;
    if(Math.abs(diff) > 40) goTo(diff > 0 ? index+1 : index-1);
  });
  track.addEventListener('mouseleave', function(){ isDragging=false; track.style.cursor='grab'; });
  track.style.cursor='grab';
});

// Concept video
document.addEventListener('DOMContentLoaded', function () {

  const videos = document.querySelectorAll('.concept-video');
  const buttons = document.querySelectorAll('.concept-video-toggle');

  function pauseAllVideos() {

    videos.forEach(function(video) {
      video.pause();

      const wrapper = video.closest('.concept-video-wrapper');
      const button = wrapper.querySelector('.concept-video-toggle');

      wrapper.classList.remove('is-playing');
      button.innerHTML = '▶';
    });

  }

  buttons.forEach(function(button) {

button.addEventListener('click', function(e) {

      const wrapper = this.closest('.concept-video-wrapper');
      const video = wrapper.querySelector('.concept-video');

      if (video.paused) {

        pauseAllVideos();

       video.muted = false;

video.play().catch(function(err){
  console.log(err);
});

        wrapper.classList.add('is-playing');
        this.innerHTML = '❚❚';

      } else {

        video.pause();

        wrapper.classList.remove('is-playing');
        this.innerHTML = '▶';
      }

    });

  });

  const observer = new IntersectionObserver(function(entries) {

    entries.forEach(function(entry) {

      if (!entry.isIntersecting) {

        const video = entry.target;
        const wrapper = video.closest('.concept-video-wrapper');
        const button = wrapper.querySelector('.concept-video-toggle');

        video.pause();

        wrapper.classList.remove('is-playing');
        button.innerHTML = '▶';
      }

    });

  }, {
    threshold: 0.3
  });

  videos.forEach(function(video) {
    observer.observe(video);
  });

});
// Concept video — mobile tap-to-expand lightbox
document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth > 767) return;

  // Dark backdrop
  var overlay = document.createElement('div');
  overlay.id = 'concept-video-overlay';
  overlay.style.cssText = [
    'display:none',
    'position:fixed',
    'inset:0',
    'background:rgba(0,0,0,0.75)',
    'z-index:9999',
    'align-items:center',
    'justify-content:center'
  ].join(';');

  // Outer wrapper — relative, no overflow hidden
  var modalWrap = document.createElement('div');
  modalWrap.style.cssText = [
    'position:relative',
    'width:88vw',
    'max-width:340px'
  ].join(';');

  // Inner modal — this one has overflow hidden for rounded corners
  var modal = document.createElement('div');
  modal.style.cssText = [
    'width:100%',
    'border-radius:14px',
    'overflow:hidden',
    'background:#000',
    'box-shadow:0 8px 40px rgba(0,0,0,0.6)'
  ].join(';');

  // Video inside modal
  var overlayVideo = document.createElement('video');
  overlayVideo.style.cssText = 'width:100%;display:block;max-height:75vh;object-fit:cover;';
  overlayVideo.setAttribute('playsinline', '');
  overlayVideo.setAttribute('controls', '');

  // Close button sits on modalWrap (no overflow hidden) so it's never clipped
  var closeBtn = document.createElement('button');
  closeBtn.innerHTML = '✕';
  closeBtn.style.cssText = [
    'position:absolute',
    'top:-14px',
    'right:-14px',
    'width:36px',
    'height:36px',
    'border-radius:50%',
    'border:2px solid #fff',
    'background:#0A0A0A',
    'color:#fff',
    'font-size:15px',
    'font-weight:700',
    'cursor:pointer',
    'display:flex',
    'align-items:center',
    'justify-content:center',
    'z-index:10000',
    'box-shadow:0 2px 10px rgba(0,0,0,0.5)'
  ].join(';');

  // Structure: overlay > modalWrap > modal > video
  //                               > closeBtn (floats outside modal)
  modal.appendChild(overlayVideo);
  modalWrap.appendChild(modal);
  modalWrap.appendChild(closeBtn);
  overlay.appendChild(modalWrap);
  document.body.appendChild(overlay);

 function openOverlay(src, thumbnailVideo) {
    
    if (thumbnailVideo) {
      thumbnailVideo.pause();
      var wrapper = thumbnailVideo.closest('.concept-video-wrapper');
      var btn = wrapper ? wrapper.querySelector('.concept-video-toggle') : null;
      if (wrapper) wrapper.classList.remove('is-playing');
      if (btn) btn.innerHTML = '▶';
    }
    overlayVideo.src = src;
    overlayVideo.muted = false;
    overlay.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    overlayVideo.play().catch(function(){});
  }

  function closeOverlay() {
    overlayVideo.pause();
    overlayVideo.src = '';
    overlay.style.display = 'none';
    document.body.style.overflow = '';
  }

  closeBtn.addEventListener('click', closeOverlay);

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeOverlay();
  });

 document.querySelectorAll('.concept-video-wrapper').forEach(function (wrapper) {
    wrapper.addEventListener('click', function () {
      var video = wrapper.querySelector('.concept-video');
      if (!video) return;
      openOverlay(video.currentSrc || video.src, video);
    });
  });
  });